var _path, _path2, _path3, _mask, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20898 1.28906V3.28906V5.28906",
    stroke: "#FF6A00",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 15H14.8759",
    stroke: "#FF6A00",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7178 6.41504V17.1436C17.7177 17.3386 17.6409 17.525 17.5059 17.6611C17.371 17.7969 17.1891 17.8721 17.001 17.8721H1.41699C1.27587 17.8721 1.13829 17.8295 1.02148 17.751L0.912109 17.6611C0.777072 17.525 0.700232 17.3386 0.700195 17.1436V6.41504H17.7178Z",
    stroke: "#FF6A00",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_11970_58310",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.71429L2.12515 1.58571C2.35425 1.12039 2.70484 0.726853 3.13921 0.44745C3.57357 0.168046 4.07527 0.0133487 4.59032 0H13.8276C14.3548 0.00028206 14.8714 0.14884 15.3194 0.428971C15.7674 0.709101 16.1291 1.1097 16.3636 1.58571L18.4179 5.71429"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.24477 5.07355C-1.59864 5.76102 -1.3282 6.60519 -0.640736 6.95906C0.0467327 7.31293 0.890903 7.04249 1.24477 6.35502L-1.24477 5.07355ZM2.12515 1.58571L3.36992 2.22645C3.37373 2.21904 3.37748 2.21159 3.38117 2.20411L2.12515 1.58571ZM4.59032 0V-1.4C4.57823 -1.4 4.56613 -1.39984 4.55405 -1.39953L4.59032 0ZM13.8276 0L13.8284 -1.4H13.8276V0ZM16.3636 1.58571L15.1078 2.20458L15.1102 2.20939L16.3636 1.58571ZM17.1645 6.33796C17.509 7.0302 18.3494 7.31214 19.0416 6.96769C19.7339 6.62325 20.0158 5.78285 19.6714 5.09061L17.1645 6.33796ZM0 5.71429L1.24477 6.35502L3.36992 2.22645L2.12515 1.58571L0.880375 0.944978L-1.24477 5.07355L0 5.71429ZM2.12515 1.58571L3.38117 2.20411C3.49843 1.96594 3.6771 1.76608 3.89659 1.62489L3.13921 0.44745L2.38182 -0.729991C1.73259 -0.312375 1.21007 0.274834 0.869129 0.967314L2.12515 1.58571ZM3.13921 0.44745L3.89659 1.62489C4.11599 1.48376 4.36836 1.40622 4.62659 1.39953L4.59032 0L4.55405 -1.39953C3.78218 -1.37953 3.03115 -1.14767 2.38182 -0.729991L3.13921 0.44745ZM4.59032 0V1.4H13.8276V0V-1.4H4.59032V0ZM13.8276 0L13.8269 1.4C14.0912 1.40014 14.351 1.47457 14.5772 1.61602L15.3194 0.428971L16.0617 -0.758078C15.3919 -1.17689 14.6184 -1.39958 13.8284 -1.4L13.8276 0ZM15.3194 0.428971L14.5772 1.61602C14.8035 1.75753 14.9878 1.96093 15.1078 2.20457L16.3636 1.58571L17.6194 0.966854C17.2703 0.258463 16.7313 -0.339332 16.0617 -0.758078L15.3194 0.428971ZM16.3636 1.58571L15.1102 2.20939L17.1645 6.33796L18.4179 5.71429L19.6714 5.09061L17.617 0.96204L16.3636 1.58571Z",
    fill: "#FF6A00",
    mask: "url(#path-4-inside-1_11970_58310)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryActive);
export default __webpack_public_path__ + "static/media/InventoryActive.b69e232c568eaefb6aa3ce8a909af34c.svg";
export { ForwardRef as ReactComponent };